import { BadgeSelectorComponent } from 'src/app/reusables/badge-selector/badge-selector.component';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { MarketplaceService } from 'src/app/gamification/command-center/services/marketplace.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cv-configure-rewards-brackets',
  templateUrl: './configure-rewards-brackets.component.html',
  styleUrl: './configure-rewards-brackets.component.scss'
})
export class ConfigureRewardsBracketsComponent implements OnInit, OnChanges  {
  @Input() step: number;
  @Input() numberOfRounds: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  consideredComplete: boolean = false;
  selectedRewardLevel: any = {};
  editing: boolean;
  rewardType: number;
  rewardValue: number;
  rewards = [];
  specialCharacters: RegExp = /[\\/!+<>?#&,%]/;
  showBadgeSelector: boolean;
  showRemove = [];
  // Load products related to custom rewards
  products = [];
  customRewards = [];

  rounds = null;  // This variable is for setting the number of rounds. 
  allRounds = [];
  roundsToShow = [];
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private marketplaceService: MarketplaceService,
    private dialogService: CvDialogService,
    private modalService: NgbModal,
    private cvConfigurationService: CvConfigurationService,
  ) {
    this.gs = this.gamesService.data;
    this.customRewards = this.marketplaceService.customRewards;
  }

  ngOnInit(): void {
    this.gs.modified.item.BracketsTournamentRewards = this.gs.modified.item.BracketsTournamentRewards || [this._newLevelTemplate()];
    this.rewards = this.gs.modified.item.BracketsTournamentRewards;
    this.rounds = this.numberOfRounds !==undefined ? this.numberOfRounds : 0;

    this.initializeRoundsTitle();
    if (this.rewards.length > 0) {
      this.rewards.forEach((item, index) => {
        item.isSystemReward = item.isSystemReward,
          item.Msg = '',
          item.Coins = { editing: false, rewardType: this.gs.rewardOptions.Coins, rewardValue: item.Coins.rewardValue },
          item.XP = { editing: false, rewardType: this.gs.rewardOptions.XP, rewardValue: item.XP.rewardValue },
          item.Custom = { editing: false, rewardType: this.gs.rewardOptions.Custom, rewardValue: item.Custom.rewardValue, rewardText: this.getRewardName(item.Custom.rewardValue) },
          item.Badge = { editing: false, rewardType: this.gs.rewardOptions.Badge, rewardValue: item.Badge.rewardValue }
        //item.Gems = { editing: false, rewardType: this.gs.rewardOptions.Gems, rewardValue: item.Gems.rewardValue }  NOTE: This is in case Gems are added to the rewards in the future.

        if (index < this.allRounds.length) {
          this.roundsToShow.push(this.allRounds[index]);
        }
      });
    } else {
      this.roundsToShow.push(this.allRounds[0]);
    }
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.numberOfRounds) {
      this.rounds = parseInt(changes.numberOfRounds.currentValue);

      if (this.rewards.length > this.rounds) {
        const rewardsToRemove = this.rewards.slice(-(this.rewards.length-this.rounds));

        rewardsToRemove.forEach(rewards => {
          this.removeRewardPrize(rewards);
        });
      }
    }
  }

  initializeRoundsTitle(): void {
    this.allRounds = [
      this.gamesService.getLocalizedMessage("Round_1_Final", "Final"),
      this.gamesService.getLocalizedMessage("Round_2_Semi_Finals", "Semi Finals"),
      this.gamesService.getLocalizedMessage("Round_3_Quarter", "Quarters"),
      this.gamesService.getLocalizedMessage("Round_4_Octaves", "Octaves")
    ];
  }

  msg = (key, fallback) => {
    return this.gamesService.getValidationMessage(key, fallback);
  };

  _newLevelTemplate(): any {
    return {
      isSystemReward: true,
      Msg: '',
      Coins: this._newRewardTemplate(this.gs.rewardOptions.Coins),
      XP: this._newRewardTemplate(this.gs.rewardOptions.XP),
      Custom: this._newRewardTemplate(this.gs.rewardOptions.Custom),
      Badge: this._newRewardTemplate(this.gs.rewardOptions.Badge)
      // Gems: this._newRewardTemplate(this.gs.rewardOptions.Gems)  NOTE: This is in case Gems are added to the rewards in the future.
    };
  }

  _newRewardTemplate(type: number): any {
    return {
      editing: false,
      rewardType: type,
      rewardValue: 0,
      rewardText: ''
    }
  }

  getRewardName(productID) {
    const product = this.customRewards.filter((r: any) => { return r.PointStoreProductID == productID })[0];
    return product != null ? product.Title : '';
  }

  addNewPrize(): void {
    this.rewards.push(this._newLevelTemplate());
    if (this.roundsToShow.length < this.rounds) {
      const nextRound = this.allRounds[this.roundsToShow.length];
      this.roundsToShow.push(nextRound);
    }
  }

  removeRewardPrize(reward): void {
    if (reward.RuleLevelID > 0) { //already saved to db
      if (this.gs.modified.item.RemovedRuleLevelIDs == null)
        this.gs.modified.item.RemovedRuleLevelIDs = [];
      this.gs.modified.item.RemovedRuleLevelIDs.push(reward.RuleLevelID);
    }

    this.rewards.splice(this.rewards.indexOf(reward), 1);
    this.roundsToShow.splice(this.roundsToShow.indexOf(this.roundsToShow), 1);
  }

  confirmRemoveReward(reward) {
    if (this.rewards == null || this.rewards.length < 2) {
      showErrorMessage(
        this.gamesService.getLocalizedMessage("Top_Dog_Remove_Level_Failed", "Cannot remove the last reward level in this game."),
        this.gamesService.getLocalizedMessage("Action_Not_Allowed", "Action Not Allowed")
      );
      return;
    }

    let title = this.gamesService.getLocalizedMessage("Confirm_Remove", "Confirm Remove");
    let message = this.gamesService.getLocalizedMessage("Remove_TopDog_Level", "Are you sure you want to remove this level? This operation cannot be undone.");

    this.dialogService.showConfirmDialog(
      title, message, false, () => { this.removeRewardPrize(reward); }
    );
  }

  handleRewardBlur(i, $event) {
    if (!this.rewards[i].isSystemReward) {
      this.rewards[i].Msg = this.validateString(this.rewards[i].Custom.rewardText);
      this.onCustomRewardSelected(i);
    } else {
      var $elem = $($event.target);
      var resetToZero = false; //If the box is empty or invalid, should the value reset to zero?
      if ($elem != null) {
        var val = parseFloat($elem[0].value);
        if (val == null || isNaN(val)) {
          resetToZero = true;
        }
      }

      if (resetToZero) {
        $elem[0].value = 0;
      }
    }

    this.checkForComponentCompletion();
  }

  getProductList(): any {
    for (var i = 0; i < this.customRewards.length; i++) {
      if (this.products.filter((f) => { return f == this.customRewards[i].Title }).length == 0 && this.customRewards[i].Title != "") {
        this.products.push(JSON.parse(JSON.stringify(this.customRewards[i].Title)));
      }
    }
    return this.products;
  }

  onCustomRewardSelected(i: number): void {
    const rewardSelected = this.customRewards.filter((r: any) => { return r.Title.toLowerCase() == this.rewards[i].Custom.rewardText.toLowerCase().trim() });
    this.rewards[i].Custom.rewardValue = rewardSelected.length > 0 ? rewardSelected[0].PointStoreProductID : 0;
  }

  checkForComponentCompletion(): void {
    if (!this.consideredComplete) {
      //check each level and if anything is set at all, set complete to true
      if (this.rewards != null) {
        for (var i = 0; i < this.rewards.length; i++) {
          if ((this.rewards[i].isSystemReward && (this.rewards[i].Coins.rewardValue > 0 || this.rewards[i].XP.rewardValue > 0)) ||
            (!this.rewards[i].isSystemReward && this.rewards[i].Msg.length == 0)) {
            this.consideredComplete = true;

            //Fire one time event to unlock the next component
            var eventArgs = {
              currentStep: this.step - 1,
              unlocks: this.componentOptions.unlocks
            };

            this.componentComplete.emit(eventArgs);
          }
        }
      }
    }
  }

  validateString(text: string): string {
    let message = '';
    //Check if the name has one of the restricted characteres
    if (this.specialCharacters.test(text)) {
      message = this.msg("Game_Invalid_Characters", "The following characters are not permitted: \ / ! + < > ? # & , %");
    }

    if (text === "" || text === " ") {
      message = this.msg("Custom_Prize_Required", "You haven't entered a name for the reward.")
    }

    return message;
  }

  popBadgeSelector(rewardLevel: number): void {
    this.showBadgeSelector = true;
    this.selectedRewardLevel = rewardLevel;

    const modalRef = this.modalService.open(BadgeSelectorComponent, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'md-lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    //Sending input value
    modalRef.componentInstance.header = this.gamesService.getLocalizedMessage("Select_Badge", "Select your badge");
    modalRef.componentInstance.showWhen = this.showBadgeSelector;

    //Catching event answer
    modalRef.componentInstance.onBadgeSelected.subscribe(result => {
      this.selectedRewardLevel.Badge.rewardValue = result;
      modalRef.close();
    });
  }

  removeBadge(badge): void {
    badge.rewardValue = 0;
  }
}
